import { createRef } from 'react';
import { eChatLeadsTabs } from './Messenger.enum';
import { tMessengerContext } from './Messenger.types';

export const initialState: tMessengerContext = {
  leads: [],
  leadsQuery: '',
  selectedTab: eChatLeadsTabs.ALL,
  inputValue: '',
  loading: false,
  isLastPage: false,
  searchInputRef: createRef<HTMLInputElement>(),
  setSelectedTab: () => {},
  setInputValue: () => {},
  setLoading: () => {},
  setLeads: () => {},
  getMoreLeads: () => Promise.resolve(),
  undeliveredCount: null,
};
